import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";
import { NucleoIcone } from "@/components/InnovaIAAluna";
import { Texto } from "@/components/IATexto";

function Duvida({ x, onMudou }) {
  const [resp, setResp] = useState("");
  const [busy, setBusy] = useState(false);
  const responder = async () => {
    setBusy(true);
    try { await api.post(`/prof/innova-ia/${x.id}/responder`, { resposta: resp }); toast.success("Resposta enviada para a aluna."); onMudou(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const d = x.duvida || {};
  return (
    <div className={`bg-white rounded-xl border shadow-sm p-5 space-y-3 ${d.status === "aberta" ? "border-amber-300" : "border-slate-200"}`}>
      <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
        <b className="text-slate-700">{x.por}</b>{d.turma && <span>· turma {d.turma}</span>}<span>· {new Date(d.em || x.at).toLocaleString("pt-BR")}</span>
        {d.status === "aberta" ? <span className="ml-auto rounded-full bg-amber-100 text-amber-800 font-semibold px-2 py-0.5">Aguardando você</span>
          : <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-green-100 text-[#1E9E2A] font-semibold px-2 py-0.5"><CheckCircle2 className="h-3 w-3" /> Respondida</span>}
      </div>
      <div className="font-semibold text-slate-800">{x.pergunta}</div>
      <details className="rounded-lg bg-slate-50 border border-slate-200 px-3 py-2">
        <summary className="text-xs font-semibold text-slate-500 cursor-pointer">O que a IEP Intelligence respondeu</summary>
        <div className="mt-2"><Texto t={x.resposta} /></div>
      </details>
      {d.status === "aberta" ? (
        <div className="space-y-2">
          <Textarea value={resp} onChange={(e) => setResp(e.target.value)} rows={3} placeholder="Sua resposta para a aluna (ela vê na janela da IEP Intelligence)" />
          <Button size="sm" disabled={busy || resp.trim().length < 3} onClick={responder} className="text-white" style={{ background: "#1E9E2A" }}>{busy && <Loader2 className="h-4 w-4 animate-spin mr-1.5" />}Responder</Button>
        </div>
      ) : <div className="rounded-lg bg-green-50 border border-green-200 p-3 text-sm text-slate-700"><b className="text-[#1E9E2A]">{d.respondida_por || "Professora"}:</b> {d.resposta}</div>}
    </div>
  );
}

/** Dúvidas que as alunas da turma enviaram pela IEP Intelligence ("Perguntar à professora"). */
export default function DuvidasIA() {
  const [dados, setDados] = useState(null);
  const carregar = () => api.get("/prof/innova-ia/duvidas").then((r) => setDados(r.data)).catch(() => setDados({ itens: [] }));
  useEffect(() => { carregar(); }, []);
  return (
    <div className="max-w-4xl mx-auto px-5 md:px-8 py-6 space-y-4">
      <div className="flex items-center gap-2"><span className="text-[#1E9E2A]"><NucleoIcone className="h-7 w-7" /></span><h1 className="font-display text-2xl font-bold text-slate-900">Dúvidas da IEP Intelligence</h1></div>
      <p className="text-sm text-slate-500">Quando a resposta da IA não resolve, a aluna envia a dúvida para você. A sua resposta aparece para ela e passa a ser usada para perguntas iguais.</p>
      {dados === null ? <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
        : dados.itens.length === 0 ? <div className="bg-white rounded-xl border border-slate-200 p-10 text-center">
            <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl text-[#1E9E2A] bg-green-50"><NucleoIcone className="h-8 w-8" /></div>
            <p className="mt-3 font-semibold text-slate-700">Nenhuma dúvida por enquanto</p>
            <p className="mt-1 text-sm text-slate-500">Quando a IA não souber responder uma aluna, a pergunta aparece aqui para você.</p>
          </div>
        : dados.itens.map((x) => <Duvida key={x.id} x={x} onMudou={carregar} />)}
    </div>
  );
}
